import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { TextInput } from 'react-native-paper';
import { Colors } from '../../themes';
import { colors as CropCircleColors } from '../crop-circle/tokens';
import { DebouncedTextInput } from '../forms/debouncedTextInput';

type LabelSearchInputProps = {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
};

export const LabelSearchInput: React.FC<LabelSearchInputProps> = ({
  value,
  onChangeText,
  placeholder,
}) => {
  const { t } = useTranslation();

  return (
    <View style={styles.searchContainer}>
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceFunc={() => {}}
        placeholder={placeholder || t('activity.filter.searchLabels')}
        value={value}
        onBlur={() => {}}
        onChangeText={onChangeText}
        left={<TextInput.Icon icon="magnify" color={Colors.grayFill} />}
        right={
          value ? (
            <TextInput.Icon
              icon="close"
              size={20}
              color={Colors.black}
              onPress={() => onChangeText('')}
            />
          ) : (
            <View />
          )
        }
        height={44}
        disableInnerStyle={true}
        backgroundColor={CropCircleColors.neutral[200]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  searchContainer: {
    borderBottomWidth: 0,
    marginBottom: 8,
    paddingHorizontal: 4,
    paddingVertical: 8,
  },
});
